module.exports = __webpack_public_path__ + "img/magento.8cfefda5.png";